import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Detect backend URL
const API_BASE =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://upsc-backend-353e.onrender.com");

const DashboardOverview = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [inactiveUsers, setInactiveUsers] = useState(0);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("user"))?.token;
        if (!token) {
          toast.error("Authentication token not found.");
          return;
        }

        const res = await axios.get(`${API_BASE}/api/admin/stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const { total, active, inactive } = res.data;
        setTotalUsers(total);
        setActiveUsers(active);
        setInactiveUsers(inactive);
      } catch (err) {
        console.error("Failed to fetch stats:", err);
        toast.error("Failed to load dashboard stats.");
      }
    };

    fetchStats();
  }, []);

  const chartData = [
    { name: "Active", value: activeUsers },
    { name: "Inactive", value: inactiveUsers },
  ];
  const COLORS = ["#4ade80", "#f87171"];

  return (
    <div className="p-6 bg-transparent rounded-3xl shadow-2xl">
      <ToastContainer position="top-right" autoClose={3000} />
      <h2 className="text-3xl font-bold text-center mb-8 text-blue-700 dark:text-blue-300">
        📊 Dashboard Overview
      </h2>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="bg-gradient-to-br from-blue-400 to-blue-600 p-6 rounded-2xl shadow-lg text-white hover:shadow-2xl transition-shadow"
        >
          <p>Total Users</p>
          <p className="text-4xl font-bold mt-2">{totalUsers}</p>
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="bg-gradient-to-br from-green-400 to-green-600 p-6 rounded-2xl shadow-lg text-white hover:shadow-2xl transition-shadow"
        >
          <p>Active Users</p>
          <p className="text-4xl font-bold mt-2">{activeUsers}</p>
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="bg-gradient-to-br from-red-400 to-red-600 p-6 rounded-2xl shadow-lg text-white hover:shadow-2xl transition-shadow"
        >
          <p>Inactive Users</p>
          <p className="text-4xl font-bold mt-2">{inactiveUsers}</p>
        </motion.div>
      </div>

      {/* Pie Chart */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700">
        <h3 className="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-300">
          User Distribution
        </h3>
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) =>
                `${name}: ${(percent * 100).toFixed(0)}%`
              }
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DashboardOverview;
